/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualDigestMultibase: core.serialization.ObjectSchema<
    serializers.EqualDigestMultibase.Raw,
    Truvity.EqualDigestMultibase
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace EqualDigestMultibase {
    export interface Raw {
        value: string;
    }
}
